import { Children, cloneElement, forwardRef } from 'react';

import type { ForwardedRef, ReactElement, ReactNode } from 'react';

export type DistributorProps<TProps extends Record<never, unknown>> =
  & {
    children:
      | ReactElement<TProps>
      | Array<ReactElement<TProps>>
      // | ((props: { [Key in keyof Omit<TProps, 'children'>]: TProps[Key] }) => ReactElement);
      | ((props: { [Key in keyof Omit<TProps, 'children'>]: TProps[Key] }) => ReactElement<TProps>);
  } // & TProps;
  & { [Key in keyof TProps]: TProps[Key] };

///
// Provides a uniform API for distributing Properties to a generic type of children.
// @param children
// @param props
// @example
//  *  // Pass Props to ReactElement
//  *  <Distributor value={value}>
//  *    <Component />
//  *  </Distributor
// @example
//  *  // Pass Props multiple ReactElements
//  *  <Distributor value={value}>
//  *    <Component />
//  *    <Component />
//  *  </Distributor
// @example
// // Pass props while instantiating Component
//  *  <Distributor value={value}>
//  *    {Component}
//  *  </Distributor
// @example
// // Pass props over renderProps
//  *  <Distributor value={value}>{
//  *    (props) => (
//  *      <Component {...props} />
//  *    )}
//  *  </Distributor
// @example
// // Destructure renderProps
//  *  <Distributor value={value}>{
//  *    ({value}) => (
//  *      <Component value={value} />
//  *    )}
//  *  </Distributo
//
export const Distributor = <
  TProps extends Record<PropertyKey, unknown> = Record<PropertyKey, unknown>,
>({
  children,
  ...props
}: DistributorProps<TProps>): ReactElement | ReactElement[] | null => {
  if (typeof children === 'function') {
    return children( props );
  }

  return Children.map( children, (child) =>
    cloneElement( child, {
      ...child.props,
      ...props,
    } ) );
};

// export const Distributor = forwardRef( function Distributor<
//   R,
//   TProps extends Record<PropertyKey, unknown> = Record<PropertyKey, unknown>,
// >(
//   { children, ...props }: DistributorProps<TProps>,
//   ref: ForwardedRef<R>
// ): ReactElement | ReactElement[] | null {
//   if (typeof children === 'function') {
//     return children( props );
//   }
//
//   return Children.map( children, (child) =>
//     cloneElement( child, {
//       ref,
//       ...child.props,
//       ...props,
//     } ) );
// } );
